module.exports = __webpack_public_path__ + "media/images/svgs/PRO-388d96c863fc2b9de480d0b6acc1cd61.svg";